import { render, staticRenderFns } from "./ContactListV2.vue?vue&type=template&id=39a3c2ae&scoped=true"
import script from "./ContactListV2.vue?vue&type=script&lang=js"
export * from "./ContactListV2.vue?vue&type=script&lang=js"
import style0 from "./ContactListV2.vue?vue&type=style&index=0&id=39a3c2ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3c2ae",
  null
  
)

export default component.exports